import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from '@one-thd/sui-atomic-components';

export const SeeMoreOptions = ({
  totalNumberOfOptions,
  canonicalUrl,
  isMobile
}) => {

  const hasMultipleOptions = totalNumberOfOptions > 1;

  const tailwindClasses = classNames({
    'sui-hidden': !hasMultipleOptions && isMobile,
    'sui-invisible': !hasMultipleOptions && !isMobile,
    'sui-flex sui-justify-center sui-items-center sui-w-full': hasMultipleOptions
  });

  return (
    <div className={tailwindClasses}>
      <Link variant="body-xs" href={canonicalUrl}>
        See More Options
      </Link>
    </div>
  );
};

SeeMoreOptions.propTypes = {
  totalNumberOfOptions: PropTypes.number,
  canonicalUrl: PropTypes.string,
  isMobile: PropTypes.bool
};

SeeMoreOptions.defaultProps = {
  totalNumberOfOptions: 0,
  canonicalUrl: '',
  isMobile: false
};

SeeMoreOptions.displayName = 'SeeMoreOptions';
